/**
 * @description: 관리자 > 총괄표 관리
 */
import http from '../../../../api/http';

/**
 * @description: 관리자 > 총괄표 관리 > 페이징 조회
 * @param {
 *   pageNo: 1,
 *   size: 10,
 * }
 */
function retrieveAllCurriculumPaging(paramObj) {
    return http.post('/admin/curriculum/retrieveAllCurriculumPaging', {
        pageNumber: paramObj.pageNo || 0,
        size: paramObj.size || 10,
    });
}

/**
 * @description: 관리자 > 총괄표 관리 > 개별 개방 여부 변경 (Y)
 * @param {*} summaryIds
 */

function updateCurriculumOpenYnY(summaryIds) {
    return http.post('/admin/curriculum/updateCurriculumOpenYnY', {
        summaryIds,
    });
}

/**
 * @description: 관리자 > 총괄표 관리 > 개별 개방 여부 변경 (N) 
 * @param {*} summaryIds
 */

function updateCurriculumOpenYnN(summaryIds) {
    return http.post('/admin/curriculum/updateCurriculumOpenYnN', {
        summaryIds,
    });
}

/**
 * @description: 관리자 > 총괄표 생성
 * @param {
 * summaryName: "총괄표명",
 * summaryImageName": "총괄표이미지명",
 * summaryImageSize": "총괄표이미지사이즈",
 * summaryImageDir": "총괄표이미지위치",
 * curriculumList": [
  * {
    * "curriculumGb": "과정정보 구분(기초 = "01", 심화 = "02")",
    * "curriculumOrder": 순서,
    * "curriculumFiled": "분야",
    * "curriculumName": "과정명",
    * "curriculumLabel": "라벨 (없음 = "", 취업중점 = "취업중점", 채용연계 = "채용연계")",
    * "curriculumMth": "방식",
    * "curriculumDays": "기간",
    * "curriculumHours": "시간",
    * "curriculumTrgt": "대상",
    * "curriculumIntro": "과정소개",
    * "annualSchedule": "연간교육일정 (ex. 1, 2, 3, 5, 12)"
   * }
 * ]
 * }
*/
function createCurriculum(paramObj) {
    return http.post('/admin/curriculum/createCurriculum', {
        ...paramObj,
    });
}

/**
 * @description: 관리자 > 총괄표 수정
 * @param {
 * summaryName: "총괄표명",
 * summaryImageName": "총괄표이미지명",
 * summaryImageSize": "총괄표이미지사이즈",
 * summaryImageDir": "총괄표이미지위치",
 * curriculumList": [
  * {
    * "curriculumGb": "과정정보 구분(기초 = "01", 심화 = "02")",
    * "curriculumOrder": 순서,
    * "curriculumFiled": "분야",
    * "curriculumName": "과정명",
    * "curriculumLabel": "라벨 (없음 = "", 취업중점 = "취업중점", 채용연계 = "채용연계")",
    * "curriculumMth": "방식",
    * "curriculumDays": "기간",
    * "curriculumHours": "시간",
    * "curriculumTrgt": "대상",
    * "curriculumIntro": "과정소개",
    * "annualSchedule": "연간교육일정 (ex. 1, 2, 3, 5, 12)"
   * }
 * ]
 * }
*/
function updateCurriculum(paramObj) {
    return http.post('/admin/curriculum/updateCurriculum', {
        ...paramObj,
    });
}

/**
 * @description: 관리자 > 총괄표 삭제
 * @param {*} summaryId
 */
function deleteCurriculum(summaryId) {
    return http.post('/admin/curriculum/deleteCurriculum', {
        summaryId,
    });
}

/**
 * @description: 관리자 > 총괄표 복사
 * @param {*} summaryId
 */
function copyCurriculum(summaryId) {
    return http.post('/admin/curriculum/copyCurriculum', {
        summaryId,
    });
}

/**
 * @description: 관리자 > 총괄표 상세 조회
 * @param {*} summaryId
 */
function retrieveCurriculumSummaryDetail(summaryId) {
    return http.get(`/admin/curriculum/retrieveCurriculum?summaryId=${summaryId}`); 
}

/**
 * @description: 관리자 > 총괄표 교육프로그램(과정) 상세 조회
 * @param {*} curriculumId
 */
function retrieveCurriculumDetail(curriculumId) {
    return http.get(`/admin/curriculum/retrieveCurriculumInfo?curriculumId=${curriculumId}`); 
}

/**
 * @description: 사용자 > 교육프로그램 총괄표 조회
 * @param {*} 
 */
function retrieveUserCurriculum() {
    return http.get('/user/curriculum/retrieveCurriculum');
}

/**
 * @description: 사용자 > 총괄표 교육프로그램(과정) 상세 조회
 * @param {*} curriculumId
 */
function retrieveUserCurriculumDetail(curriculumId) {
    return http.get(`/user/curriculum/retrieveCurriculumInfo?curriculumId=${curriculumId}`); 
}

export default {
    retrieveAllCurriculumPaging,
    retrieveCurriculumSummaryDetail,
    retrieveCurriculumDetail,
    updateCurriculumOpenYnY,
    updateCurriculumOpenYnN,
    createCurriculum,
    updateCurriculum,
    deleteCurriculum,
    copyCurriculum,
    retrieveUserCurriculum,
    retrieveUserCurriculumDetail,
}
